import { ETooltipIntents, ETypographyIntents } from '@src/typings';
import { inputVariants } from '@src/utilities/inputVariants';
import { Input as InputAntD } from 'antd';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTheme, withTheme } from '../ThemeProvider';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
import { TextAreaProps } from './types';

const TextareaComponent = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
        {
            intent,
            size,
            className,
            children,
            label,
            name,
            error,
            isRequired,
            rows = 4,
            maxLength,
            ...props
        },
        ref
    ) => {
        const { theme } = useTheme();

        return (
            <div>
                <div className="flex w-full items-center justify-between mb-2.5">
                    <Typography
                        intent={ETypographyIntents.Regular}
                        className="flex items-center justify-start gap-x-1"
                        style={{
                            color: theme.colors.secondary.main.text,
                        }}
                    >
                        <span>{label}</span>
                        <span
                            className="text-lg"
                            style={{ color: theme.colors.error.main.filled }}
                        >
                            {isRequired ? '*' : ''}
                        </span>
                    </Typography>
                    {props.help ? (
                        <Tooltip
                            title={props.help}
                            color="secondary"
                            intent={ETooltipIntents.Question}
                        />
                    ) : (
                        ''
                    )}
                </div>
                <InputAntD.TextArea
                    ref={ref}
                    rows={rows}
                    status={error ? 'error' : props.status}
                    variant={intent}
                    className={twMerge(
                        inputVariants({
                            className,
                            intent,
                            size,
                            error: Boolean(error),
                        })
                    )}
                    maxLength={maxLength}
                    {...props}
                />
                <div className="flex justify-end">
                    {error && (
                        <Typography
                            intent={ETypographyIntents.Badge}
                            className="mt-1"
                            style={{ color: theme.colors.error.main.filled }}
                        >
                            {error}
                        </Typography>
                    )}
                </div>
            </div>
        );
    }
);

TextareaComponent.displayName = 'TextareaComponent';

export const Textarea = withTheme(TextareaComponent);
